module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter07"
    }
  }), _vm._v("CHAPTER SEVEN")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Wednesday, February 17")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("10:55 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her 911 call yielded a patrol unit and an investigator from the Medical Examiner’s Office, who’d introduced himself as Investigator Hwang. Apparently, they couldn’t take her word for it that her mother had killed herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The patrolman babysat her while the ME investigator looked at her mother. He explained that she had to stay put because the detective would need to ask her some questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Where did he think she would go? Alex wondered, struggling to keep hysteria at bay. Bar hopping? To visit friends?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Is there someone you can call?” the officer asked gently. “A family member?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I have no . . . my mother was my only fam—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex choked on the last. She saw the sympathy in his eyes. He was young, surname and coloring indicated Italian decent. Judging by his wedding band, he was married; he might even have a kid or two; and likely boasted an extended family that included aunts and uncles, cousins, nephews and nieces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Young Officer Pagani couldn’t understand what it felt like to be alone. To have no one. He couldn’t understand it, but he could pity it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“A friend then?” he offered. “A coworker?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She nodded, retrieved her phone and dialed Tim’s cell. It went directly to voice mail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("His cell was off. He must have found company for the night.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("“Tim, it’s me. I’m at Mom’s. She’s . . . oh my God, Tim, she killed herself. Call me when you get this, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She closed her phone and turned back to the patrolman. “Is it okay if I sit?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I suggest it. It may be awhile yet. Thirty minutes even.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He hit it on the button. Exactly thirty minutes later, the investigator, a trim Asian man with a no-nonsense demeanor, found her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Ms. Owens?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Owens was my maiden name. It’s Clarkson now, though I’ve been thinking of changing it back.” She was rambling but couldn’t seem to stop herself. “I mean, since the divorce.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He nodded, took a small spiral notebook from his trench pocket. “I’m sorry for your loss.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Could you tell me how you happened to be here tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“My mother left a message on my cell. I was working. She sounded—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Where do you work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m a bartender at Third Place. On Sixteenth Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Nice place. How’d she sound?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Upset. She was crying. So I came to check on her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Again he jotted a note. “Her message, what did she say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex struggled to think clearly. “She said she was sorry . . . that she was ready to tell me everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Everything,” he repeated. “What does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("How did she explain? Alex wondered. It didn’t make sense, even to her. “Mom refused to talk about the past. My father. We argued about it—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The last time I saw her. Though it wasn’t the first time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“When was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Day before yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Monday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She thought a moment. “Yes. In the afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“And that’s when you argued?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex nodded. “She wasn’t taking her meds. Another bone of contention.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What kind of meds?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Valproate and Seroquel. She suffered from bipolar disorder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("“Why wasn’t she taking her medication?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Didn’t like the way it made her feel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll need the name of her prescribing physician.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Dr. Connor. I can get her number.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’d appreciate it.” He cleared his throat. “She didn’t leave a note. Do you find that odd?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex frowned. She hadn’t even thought about a note until now. “I don’t know, I . . . Do you think it means something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Maybe. Maybe not. Statistically, overwhelmingly, suicide victims do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh.” She frowned. “I just assumed . . . You don’t think—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Tim burst into the house. “Alex! I came as soon as I got your message!” She ran to meet him and he enfolded her in his arms. “Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She nodded and drew away. “This is Investigator Hwang. Investigator, my ex-husband, Tim Clarkson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The two men greeted each other. “How well did you know the deceased, Mr. Clarkson?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Her mother. The deceased.")]), _vm._v(" Alex curved her arms around her middle, struggling to hold it together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Dr. Clarkson,” he corrected. “I’m a psych professor at State. And I knew her well enough to not be all that surprised she took her own life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The investigator’s eyebrows lifted ever so slightly. “Is that so?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“She wasn’t a stable woman. And she’d attempted it before. Twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Investigator Hwang looked at Alex as if for clarification. She gave it to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Look, for those suffering bipolar disorder, depression isn’t like what your everyday person experiences. The lows are really low, the darkness as black as you can imagine. It doesn’t take that much to push them over the edge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Interesting choice of words, Professor.” He turned his attention to Alex and motioned to the paintings. “What happened here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“She did this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His eyebrows shot up in disbelief. “"), _c('em', [_vm._v("She")]), _vm._v(" destroyed her own artwork?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex nodded. “She’d go on creative binges, then destroy what she created when she fell into despair.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The investigator noted the fact, then closed his notebook. “The state requires an autopsy on all unexplained deaths. This looks pretty cut and dried to me, but it’s up to the pathologist to call it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("“An autopsy,” she repeated, knees weak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The Medical Examiner’s Office will notify you when her remains are released. In the meantime, if anything unexpected crops up, I’ll call you. Again, Ms. Clarkson, I’m sorry for your loss.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd61d63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter07.vue
// module id = 102
// module chunks = 0